import {
  ViewEncapsulation, Injectable, Component,
  OnInit, Input, OnChanges, SimpleChange, Output, EventEmitter
} from "@angular/core";
import * as _ from "lodash";
import * as moment from "moment";
moment.locale("zh-tw");

@Component({
  selector: "app-chipsee-a9-systeminfo",
  templateUrl: "./chipsee-a9-systeminfo.component.html",
  styleUrls: ["./chipsee-a9-systeminfo.component.css"]
})
export class ChipseeA9SysteminfoComponent implements OnInit, OnChanges {
  @Input() Item: any = undefined;
  Uptimestr = "";
  constructor() { }

  ngOnInit() {

  }
  async ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    if (this.Item !== undefined && this.Item !== undefined) {
      this.Uptimestr = moment.utc(moment.duration(this.Item.uptime, "seconds").as("milliseconds")).format("YYYY-MM-DD HH:mm:ss").toString();
    }
  }
  bytesToSize(bytes: number) {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) {
      return "0 Byte";
    }
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${Math.round(bytes / Math.pow(1024, i))} ${sizes[i]}`;
  }
}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/Component/chipsee-a9-systeminfo/chipsee-a9-systeminfo.component.ts